import React, { PropsWithChildren, createContext, useMemo, useState } from "react";
import EmulationTokenRecord from "models/view-models/emulation/emulation-token-record";
import { useGlobalState } from "../use-global-state-context";
import { useLocalStorage } from "utilities/hooks/use-local-storage";
import { FullScreenTransition } from "components/full-screen-transition/full-screen-transition";
import { t } from "utilities/localization/t";
interface EmulationModeContextState {
    token: EmulationTokenRecord | null;
    setToken: (value: EmulationTokenRecord | null) => void;
    userEmail: string;
    loadingEmulationSession: boolean;
    setLoadingEmulationSession: React.Dispatch<React.SetStateAction<boolean>>;
    endingEmulationSession: boolean;
    setEndingEmulationSession: React.Dispatch<React.SetStateAction<boolean>>;
}
const defaultState: EmulationModeContextState = {
    token: null,
    setToken: () => {},
    userEmail: "",
    loadingEmulationSession: false,
    setLoadingEmulationSession: () => {},
    endingEmulationSession: false,
    setEndingEmulationSession: () => {},
};
export const EmulationModeContext = createContext(defaultState);
const EmulationModeContextProvider = (props: PropsWithChildren<{}>) => {
    const [token, setToken] = useLocalStorage<EmulationTokenRecord | null>("token", null);
    const [loadingEmulationSession, setLoadingEmulationSession] = useState(false);
    const [endingEmulationSession, setEndingEmulationSession] = useState(false);
    const { record: globalState } = useGlobalState();
    const userEmail = globalState.currentIdentity?.user?.email ?? "";
    const value: EmulationModeContextState = {
        token,
        setToken,
        userEmail,
        loadingEmulationSession,
        setLoadingEmulationSession,
        endingEmulationSession,
        setEndingEmulationSession,
    };
    const emulationTransitionText = useMemo(() => {
        return loadingEmulationSession
            ? t("loadingEmulationSession")
            : endingEmulationSession
            ? t("endingEmulationSession")
            : "";
    }, [endingEmulationSession, loadingEmulationSession]);
    return loadingEmulationSession || endingEmulationSession ? (
        <FullScreenTransition transitionText={emulationTransitionText} />
    ) : (
        <EmulationModeContext.Provider value={value}>
            {props.children}
        </EmulationModeContext.Provider>
    );
};
export { EmulationModeContextProvider };
